module.exports = __webpack_public_path__ + "img/yd.e0bd5372.png";